import { defineComponent, onMounted, onUnmounted } from 'vue';
import ActNavigation from '@/presentation/components/act-access-modal/act-navigation/act-navigation.vue';
import ActAccessModalCode from '@/presentation/components/act-access-modal/act-access-modal.code';

export default defineComponent({
	components: {
		ActNavigation
	},
	setup: () => {
		const code = new ActAccessModalCode();

		onMounted(code.mounted.bind(code));
		onUnmounted(code.unmounted.bind(code));

		return {
			modalContent: code.modalContent,
			ComponentForActiveStep: code.ComponentForActiveStep
		};
	}
});

